import '@/index.css'
import ReactDOM from 'react-dom/client'

import { App } from '@/App'
import * as Sentry from '@sentry/react'

void (async () => {
  try {
    window.env = await fetch('/api/env').then((res) => res.json())
    console.log('Environment variables: ', window.env)
  } catch (error) {
    console.error('Error fetching environment variables: ', error)
    return
  }

  if (window.env.APP_ENV === 'production') {
    const noop = () => undefined
    window.console.log = noop
    window.console.debug = noop
    window.console.info = noop
  }

  if (window.env.SENTRY_ENABLED) {
    Sentry.init({
      dsn: window.env.SENTRY_DSN,
      environment: window.env.APP_ENV,
      release: window.env.APP_BUILD,
    })
  }

  // Render the app
  const rootElement = document.getElementById('root')

  if (!rootElement) {
    throw new Error('Root element not found')
  }

  if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement)
    root.render(<App />)
  }
})()
